"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntityDetailsRoute = void 0;
var use_entity_definition_named_1 = require("./use-entity-definition-named");
/**
 * Infer the entity details route path by checking for a route at the provided
 */
var useEntityDetailsRoute = function (name) {
  var entityConfig = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(name);
  var routePath = entityConfig.routes.details;
  return routePath || '/';
};
exports.useEntityDetailsRoute = useEntityDetailsRoute;